var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadingWheel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 18a376.723 376.723 0 011.268-2.164c-.663-.544-1.252-1.24-1.768-2.09A7.453 7.453 0 012.5 10a7.5 7.5 0 117.5 7.5c-.813.067-1.647-.067-2.5-.4 0 .002-.418.72-1.255 2.155C7.408 20 9.137 20 10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10c0 2.727 1.355 6.2 4 8z"
  })));
}
export default SvgLoadingWheel;